import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import Actions from "../../../components/Actions";
import { getRuptureStats } from "../../../services/dashboard.service";
import { exportFormationsRuptures } from "../../../services/export.service";

const staticItemsData = [
  {
    key: "ruptureRate",
    title: "Taux de rupture globale",
    icon: "activity",
    background: "#e6f4ff",
    isPercentage: true,
  },
  {
    key: "totalBrokenContracts",
    title: "Contrats rompus (sans poursuite)",
    icon: "close-circle",
    background: "#e8f1fd",
  },
  {
    key: "recentBrokenContracts",
    title: "Contrats rompus (avec poursuite)",
    icon: "calendar",
    background: "#e6faef",
  },
];

const StatRupture = ({ className }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getRuptureStats();
        setDashboardData(data);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch dashboard data:", err);
        setError("Impossible de charger les données du tableau de bord.");
        setDashboardData({
          ruptureRate: 0,
          totalBrokenContracts: 0,
          recentBrokenContracts: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const itemsToDisplay = staticItemsData.map(item => ({
    ...item,
    counter: dashboardData && dashboardData[item.key] !== undefined 
      ? (item.isPercentage ? `${dashboardData[item.key]}%` : dashboardData[item.key])
      : (loading ? "Chargement..." : 0),
  }));

  const handleExportFormations = async () => {
    try {
      console.log('Début de l\'export des formations...');
      const result = await exportFormationsRuptures();
      
      if (result && result.success) {
        console.log(`Export JSON téléchargé avec succès: ${result.filename}`);
        // Optionnel: afficher un message de succès à l'utilisateur
        // alert(`Fichier ${result.filename} téléchargé avec succès.`);
      } else {
        console.warn('Échec de l\'export des formations');
        alert('Erreur lors de l\'export des formations.');
      }
    } catch (error) {
      console.error('Erreur lors de l\'export des formations:', error);
      alert('Erreur lors de l\'export des formations. Veuillez réessayer.');
    }
  };

  const handleActionSelect = (selectedAction) => {
    console.log("Action sélectionnée :", selectedAction);
    switch (selectedAction) {
      case "Voir le détail":
        // Créer un objet détaillé avec toutes les données
        const detailData = {
          date: new Date().toLocaleDateString(),
          titre: "Détail des statistiques de rupture",
          donnees: dashboardData,
          statistiques: {
            tauxRupture: dashboardData?.ruptureRate ? `${dashboardData.ruptureRate}%` : "N/A",
            contratsRompusSansPoursuite: dashboardData?.totalBrokenContracts || "N/A",
            contratsRompusAvecPoursuite: dashboardData?.recentBrokenContracts || "N/A",
            totalEtudiants: dashboardData?.totalStudents || "N/A",
            etudiantsAvecRuptureRecente: dashboardData?.uniqueStudentsWithRecentBreak || "N/A"
          }
        };
        // Afficher dans la console pour débogage
        console.log("Détail des statistiques :", detailData);
        // Copier dans le presse-papiers
        navigator.clipboard.writeText(JSON.stringify(detailData, null, 2));
        break;
      case "Exporter les données":
        // Exporter les formations avec ruptures
        handleExportFormations();
        break;
      default:
        console.warn("Action non reconnue :", selectedAction);
        break;
    }
  };

  // Définition des actions pour le composant Actions
  const actions = [
    {
      title: "Exporter les données",
      action: () => handleActionSelect("Exporter les données")
    }
  ];

  return (
    <>
      <Card
        className={cn(styles.card, className)}
        title={`Statistiques des ruptures de contrat`}
        classTitle="title-red"
        head={
          <Actions
            className={styles.actions}
            classActionsHead={styles.actionsHead}
            items={actions}
            small
          />
        }
      >
        <div className={styles.overview}>
          {loading && <p>Chargement des données...</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {!loading && !error && dashboardData && (
            <>
              <div className={styles.list}>
                {itemsToDisplay.map((x, index) => (
                  <div
                    className={styles.item}
                    key={index}
                    style={{ backgroundColor: x.background }}
                  >
                    <div className={styles.icon}>
                      <Icon name={x.icon} size="24" />{" "}
                    </div>
                    <div className={styles.line}>
                      <div className={styles.details}>
                        <div className={styles.category}>{x.title}</div>
                        <div className={styles.counter}>{x.counter}</div>

                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Section des raisons de rupture supprimée à la demande de l'utilisateur */}
            </>
          )}
        </div>
      </Card>
    </>
  );
};

export default StatRupture;
